import { createInterfaceId } from "@gitlab/needle";
//#region src/usage_quota_service.ts
const UsageQuotaService = createInterfaceId("UsageQuotaService");
//#endregion
export { UsageQuotaService as t };

//# sourceMappingURL=usage_quota_service-Dyfcck0l.mjs.map